module.exports = __webpack_public_path__ + "img/undraw_login.42f3cf4a.svg";